import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Observable } from 'rxjs';
import { DialogComponent } from '../components/dialog/dialog.component';
import { DIALOG_STYLE } from '../../assets/css/ag/styles';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private _dialog: MatDialog) {}

  /**
   * Blocking dialog that is used to display a message to the user.
   * ARIA will read out the title and content of the dialog, in addition to the available buttons.
   * @param title The title of the dialog
   * @param content The content of the dialog
   * @param okLabel OK button label. Default is 'OK'
   * @param closeLabel Optional Close/Cancel button label
   * @param titleParams Optional parameters to replace placeholders in the title.
   * @param contentParams Optional parameters to replace placeholders in the content.
   * @param size The Size of the dialog
   */
  /**
   * Displays an error dialog for a failed action, automatically adjusting the message
   * based on the HTTP error status (network error, timeout, or action-specific failure).
   * @param contentKey i18n key for the action-specific failure message
   * @param err The error from the failed HTTP request
   */
  openHttpErrorDialog(contentKey: string, err?: unknown): void {
    let content = contentKey;
    if (err instanceof HttpErrorResponse) {
      if (err.status === 0) {
        content = 'DIALOG.HTTP_ERROR.NETWORK_ERROR';
      } else if (err.status === 504 || err.status === 408) {
        content = 'DIALOG.HTTP_ERROR.TIMEOUT';
      }
    }
    this.openAlertDialog('DIALOG.HTTP_ERROR.TITLE', content, 'OK');
  }

  openAlertDialog(
    title: string,
    content: string,
    okLabel = 'OK',
    closeLabel: string = null,
    titleParams: { [key: string]: string } = {},
    contentParams: { [key: string]: string } = {},
    size: DIALOG_STYLE = DIALOG_STYLE.MD,
  ): Observable<boolean> {
    return this._dialog
      .open(DialogComponent, {
        data: {
          title,
          titleParams,
          content,
          contentParams,
          okLabel,
          closeLabel,
        },
        panelClass: size,
        role: 'alertdialog',
        ariaDescribedBy: 'dialog-content',
        disableClose: true,
      })
      .afterClosed();
  }
}
